import type { ReactNode } from 'react'
import { StreamingCardMount } from './CardListStyles'

interface Props {
  children: ReactNode
  isStreaming: boolean
}

function StreamingCardContainer({ children, isStreaming }: Props) {
  if (!isStreaming) {
    return <>{children}</>
  }

  return <StreamingCardMount className="is-streaming">{children}</StreamingCardMount>
}

export default StreamingCardContainer
